import links from "@/links/links";

export default {
  actions: {
    POST(item) {
      return this.post(links.RESOLUTION_CATALOG_TAG_POST(), item);
    },
    DELETE(itemId) {
      return this.delete(links.RESOLUTION_CATALOG_TAG_DELETE(itemId), {
        delete: itemId,
      });
    },
  },
};
